import type { JSX } from 'react';

import { Loader2 } from 'lucide-react';

import {
  UsersAlertDialog as AlertDialog,
  UsersAlertDialogAction as AlertDialogAction,
  UsersAlertDialogCancel as AlertDialogCancel,
  UsersAlertDialogContent as AlertDialogContent,
  UsersAlertDialogDescription as AlertDialogDescription,
  UsersAlertDialogFooter as AlertDialogFooter,
  UsersAlertDialogHeader as AlertDialogHeader,
  UsersAlertDialogTitle as AlertDialogTitle,
} from './ui/UsersAlertDialog';

export interface IdentityProjectChangeItem {
  id: number;
  name: string;
}

interface IdentityProjectChangesConfirmDialogProps {
  open: boolean;
  toAdd: IdentityProjectChangeItem[];
  toRemove: IdentityProjectChangeItem[];
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const IdentityProjectChangesConfirmDialog = ({
  open,
  toAdd,
  toRemove,
  isLoading,
  onClose,
  onConfirm,
}: IdentityProjectChangesConfirmDialogProps): JSX.Element | null => {
  if (!open) return null;

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirmar cambios de proyecto</AlertDialogTitle>
          <AlertDialogDescription>
            <span className="flex flex-col gap-2">
              {toAdd.length > 0 && (
                <span>
                  Se otorgará acceso a: <strong>{toAdd.map((p) => p.name).join(', ')}</strong>. El usuario que se cree
                  en esos proyectos no tendrá permisos. Hay que asignárselos manualmente.
                </span>
              )}
              {toRemove.length > 0 && (
                <span>
                  Se quitará el acceso a: <strong>{toRemove.map((p) => p.name).join(', ')}</strong>. La persona perderá
                  acceso a esos proyectos de inmediato.
                </span>
              )}
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading} onClick={onClose}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction disabled={isLoading} className="gap-2" onClick={onConfirm}>
            {isLoading ? <Loader2 className="size-4 animate-spin" aria-hidden /> : null}
            Confirmar y guardar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default IdentityProjectChangesConfirmDialog;
